<div class="top-row" (resized)="onElementResized($event)">
  <ng-content select="[topContent]"></ng-content>
</div>
<div class="main-row">
  <ng-content></ng-content>
</div>


